import qs from 'qs';
import { LocationDescriptorObject } from 'history';

/**
 * Build a LocationDescriptor object that includes a querystring for the intended path.
 * Useful for creating sign-in/register paths that redirect to some other page after
 * authentication.
 *
 * @param path
 * @param intended
 */
export const withIntendedPath = (
  path: string,
  intended: string,
): LocationDescriptorObject => {
  const u = new URL(path, window.location.origin);

  const existingQuery = qs.parse(u.search, { ignoreQueryPrefix: true });

  const query = qs.stringify(
    { ...existingQuery, intended },
    { addQueryPrefix: false },
  );

  return { pathname: path, search: query };
};
